<script lang="ts" setup>
	import { type NavBarItem } from '../../../../types'
	import { twMerge } from 'tailwind-merge'
	import {imageMeta} from "@nuxt/image/dist/runtime/utils/meta";

	defineComponent({name: "NavigationMenu"})
	const props = defineProps<{
		ui?: Object,
		orientation?: 'vertical' | 'horizontal'
	}>()
	const modelValue = defineModel('items', {required: true})
	const router = useRouter()
	const route = useRoute()
	const active = ref<string>()
	const ui = props.ui ?? {}
	const slots = ref<string[]>([])

	const getChildrenRoutes = (item: NavBarItem) => {
		let urls = []
		function iterate(children: NavBarItem[]) {
			for (const child of children) {
				if (child.to)
					urls.push(typeof child.to === 'string' ? child.to : router.resolve(child.to).fullPath)
				if (child.children && child.children.length)
					iterate(child.children)
			}
		}
		if (item.children && item.children.length)
			iterate(item.children)
		if (item.to)
			urls.push(typeof item.to === 'string' ? item.to : router.resolve(item.to).fullPath)
		return urls
	}

	const vpClasses = 'has-[&_.mega-menu]:relative has-[&_.mega-menu]:min-w-screen has-[&_.mega-menu]:left-0 has-[&_.mega-menu]:rounded-none'
	ui.viewport = ui.vieport ? twMerge(vpClasses, ui.viewport) : vpClasses

	watch(route, () => {
		active.value = ''
		modelValue.value.forEach((item: NavBarItem) => {
			if (item.children && item.children.length) {
				item.active = getChildrenRoutes(item).includes(route.fullPath)
				item.defaultOpen = item.active
			}
		})
	})
	watch(modelValue, (nv: NavBarItem[]) => {
		slots.value = []
		let i: NavBarItem[] = []
		nv.forEach((item, idx) => {
			if (item.type === 'megamenu' || item.type === 'megamenu-fluid') {
				item.slot = `item${idx}` as const
				slots.value.push(`item${idx}-content`)
			}
			if (item.children && item.children.length) {
				item.active = getChildrenRoutes(item).includes(route.fullPath)
				item.defaultOpen = item.active
			}
			i.push(item)
		})
		nv = i satisfies NavBarItem[]
	}, {immediate: true, deep: true})

</script>

<template>
	<UNavigationMenu v-model="active" :items="items" :ui="ui ?? {}" :orientation="'horizontal'">
		<template v-for="slotName in slots" :key="slotName" :slot="slot" v-slot:[slotName]="slotProps">
			<UContainer as="ul" class="mega-menu" :style="slotProps.item.type === 'megamenu-fluid' ? '--ui-container: 100vw' : ''" :class="slotProps.item.menuClass">
				<component :is="slotProps.item.comp" :orientation="orientation ?? 'horizontal'" :item="slotProps.item" :close="() => active = ''" />
			</UContainer>
		</template>
		<template
			v-for="(_, slotName) in $slots"
			:key="slotName"
			:slot="slotName"
			v-slot:[slotName]="slotProps"
		>
			<slot :name="slotName" v-bind="slotProps ?? {}"></slot>
		</template>
	</UNavigationMenu>
</template>
